import React from 'react';
import Button from '../../common/Button';

export default class EditorConnectionLostAlert extends React.Component {
    render() {
        return (
            <div className="configuration-editor-connection-lost-alert">
                <div>
                    {__('There is a communication problem with the server. Please try again or contact support.')}<br/>

                    {this.props.snapshotTaken && (
                        <React.Fragment>
                            {__('A snapshot of your current configuration has been saved locally and will be restored upon refresh.')}
                        </React.Fragment>
                    )}

                    <div style={{width: '100%', height: 16}}></div>

                    <Button theme={Button.Theme.BorderOnly} color={Button.Color.White}
                            onClick={this.props.onTryAgainClick}>{__('Try again')}</Button>
                </div>
            </div>
        )
    }
}